module.exports = __webpack_public_path__ + "static/am-mono-black.5cc37d61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/am-mono-black.svg
// module id = 295
// module chunks = 95715928098905 216929306842663